import { render } from "./Journey.vue?vue&type=template&id=15a6a3a6"
import script from "./Journey.vue?vue&type=script&lang=js"
export * from "./Journey.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__